<template>
  <div>
    <div>
      <el-row :gutter="10" style="margin: 10px 0px">
        <el-col :xs="24" :lg="8" style="padding: 6px 0">
          <span>数据指标：</span>
          <el-select
            v-model="dataIndex"
            placeholder="请选择"
            @change="getShowData"
            size="mini"
          >
            <el-option
              v-for="item in dataIndexOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :xs="24" :lg="8" style="padding: 6px 0">
          <span>数据类型：</span>
          <el-select
            v-model="dataRange"
            @change="dataRangeChange"
            placeholder="请选择"
            size="mini"
          >
            <el-option
              v-for="item in dataRangeOptions"
              size="mini"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col
          :xs="24"
          :lg="8"
          style="padding: 6px 0 0"
          v-if="dataRange === 'month'"
        >
          <span style="margin-left: 24px">时间：</span>
          <el-date-picker
            class="jiance_phone_date"
            :editable="false"
            :clearable="false"
            v-model="times"
            type="month"
            value-format="yyyy-MM"
            size="mini"
            :picker-options="pickerOptions"
            @change="monthChange"
            placeholder="选择月"
          ></el-date-picker>
        </el-col>
        <el-col
          :xs="24"
          :lg="8"
          style="padding: 6px 0 0"
          v-if="dataRange === 'quarter'"
        >
          <span>
            <quarter
              style="margin-left: 24px"
              :default-value="defaultQuarterValue"
              v-on:getQuarter="getQuarter"
            ></quarter>
          </span>
        </el-col>
        <el-col
          :xs="24"
          :lg="8"
          style="padding: 6px 0 0"
          v-if="dataRange === 'year'"
        >
          <span style="margin-left: 24px">时间：</span>
          <el-date-picker
            class="jiance_phone_date"
            :editable="false"
            :clearable="false"
            type="year"
            v-model="times"
            value-format="yyyy"
            size="mini"
            :picker-options="pickerOptions"
            @change="yearChange"
            placeholder="选择年"
          ></el-date-picker>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :xs="24" :lg="8">
          <span style="margin-left: 24px">单位：</span>
          <el-select
            v-model="unit"
            placeholder="请选择"
            @change="unitChange"
            size="mini"
          >
            <el-option label="亿元" value="0.00001"></el-option>
            <el-option label="万元" value="0.1"></el-option>
            <el-option label="千元" value="1"></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin: 10px 15px">
        <el-col align="center" style="font-size: 16px"
          >全县{{
            dataIndexOptions.find((ele) => ele.value === dataIndex).label
          }}情况</el-col
        >
      </el-row>
      <el-row style="margin: 10px 15px">
        <el-col :span="24">
          <Area v-if="showArea" :area-data="areaData" />
        </el-col>
      </el-row>
    </div>
    <el-link style="margin: 10px 0px" type="primary" @click="exportData">{{
      exportLabel
    }}</el-link>
    <div>
      <el-row style="margin: 10px 0px">
        <el-col :span="24">
          <el-table
            v-loading="loading"
            border
            :height="tableData.length > 0 ? 420 : 180"
            :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
            stripe
            :data="tableData"
          >
            <el-table-column
              type="index"
              label="序号"
              fixed
              width="50"
            ></el-table-column>
            <el-table-column
              prop="district"
              fixed
              label="地区"
            ></el-table-column>
            <el-table-column
              label="企业数"
              sortable
              fixed
              width="60"
              align="center"
            >
              <template slot-scope="scope">
                <el-link type="primary" @click="showDialog(scope.row)">{{
                  scope.row.totalNum
                }}</el-link>
              </template>
            </el-table-column>
            <el-table-column :label="`工业总产值${unitStr}`">
              <el-table-column
                sortable
                :formatter="handelFix2"
                min-width="100"
                prop="this_month_gyzcz"
                label="当期"
              ></el-table-column>
              <el-table-column
                sortable
                min-width="120"
                :formatter="handelFix2"
                prop="last_year_month_gyzcz"
                label="上年同期"
              ></el-table-column>
              <el-table-column
                sortable
                :formatter="handelFix1"
                min-width="120"
                prop="gyzczRate"
                label="同比增速(%)"
              ></el-table-column>
            </el-table-column>
            <el-table-column :label="`工业销售产值${unitStr}`">
              <el-table-column
                sortable
                :formatter="handelFix2"
                min-width="100"
                prop="this_month_gyxscz"
                label="当期"
              ></el-table-column>
              <el-table-column
                sortable
                :formatter="handelFix2"
                min-width="120"
                prop="last_year_month_gyxscz"
                label="上年同期"
              ></el-table-column>
              <el-table-column
                sortable
                prop="gyxsczRate"
                :formatter="handelFix1"
                min-width="120"
                label="同比增速(%)"
              ></el-table-column>
            </el-table-column>
            <el-table-column :label="`营业收入${unitStr}`">
              <el-table-column
                sortable
                prop="this_month_yysr"
                min-width="100"
                :formatter="handelFix2"
                label="当期"
              ></el-table-column>
              <el-table-column
                sortable
                prop="last_year_month_yysr"
                min-width="120"
                :formatter="handelFix2"
                label="上年同期"
              ></el-table-column>
              <el-table-column
                prop="yysrRate"
                sortable
                min-width="120"
                :formatter="handelFix1"
                label="同比增速(%)"
              ></el-table-column>
            </el-table-column>
            <el-table-column :label="`利润总额${unitStr}`">
              <el-table-column
                sortable
                prop="this_month_lrze"
                min-width="100"
                :formatter="handelFix2"
                label="当期"
              ></el-table-column>
              <el-table-column
                sortable
                prop="last_year_month_lrze"
                min-width="120"
                :formatter="handelFix2"
                label="上年同期"
              ></el-table-column>
              <el-table-column
                prop="lrzeRate"
                sortable
                min-width="120"
                :formatter="handelFix1"
                label="同比增速(%)"
              ></el-table-column>
            </el-table-column>
            <el-table-column :label="`营业税金及附加${unitStr}`">
              <el-table-column
                prop="this_month_yysj"
                min-width="100"
                sortable
                :formatter="handelFix2"
                label="当期"
              ></el-table-column>
              <el-table-column
                prop="last_year_month_yysj"
                :formatter="handelFix2"
                min-width="120"
                sortable
                label="上年同期"
              ></el-table-column>
              <el-table-column
                prop="yysjRate"
                min-width="120"
                :formatter="handelFix1"
                sortable
                label="同比增速(%)"
              ></el-table-column>
            </el-table-column>
            <el-table-column :label="`应缴增值税${unitStr}`">
              <el-table-column
                prop="this_month_zzs"
                :formatter="handelFix2"
                min-width="100"
                sortable
                label="当期"
              ></el-table-column>
              <el-table-column
                prop="last_year_month_zzs"
                :formatter="handelFix2"
                min-width="120"
                sortable
                label="上年同期"
              ></el-table-column>
              <el-table-column
                prop="zzsRate"
                min-width="120"
                :formatter="handelFix1"
                sortable
                label="同比增速(%)"
              ></el-table-column>
            </el-table-column>
            <el-table-column label="企业用电量（万千瓦时）">
              <el-table-column
                prop="this_month_qyydl"
                sortable
                min-width="100"
                :formatter="handelFix2"
                label="当期"
              ></el-table-column>
              <el-table-column
                prop="last_year_month_qyydl"
                sortable
                min-width="120"
                :formatter="handelFix2"
                label="上年同期"
              ></el-table-column>
              <el-table-column
                prop="qyydlRate"
                sortable
                min-width="120"
                :formatter="handelFix1"
                label="同比增速(%)"
              ></el-table-column>
            </el-table-column>
            <!-- <el-table-column
              prop="addValue"
              sortable
              min-width="120"
              :formatter="handelFix2"
              label="增加值率"
            ></el-table-column>-->
          </el-table>
        </el-col>
      </el-row>
      <div class="pageBox">
        <!-- <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20,30,50,100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next"
          :total="total"
        ></el-pagination> -->
      </div>
    </div>
    <el-dialog
      :title="`${areaName}`"
      :visible.sync="dialogTableVisible"
      width="95%"
      @close="closeMe"
      v-if="dialogTableVisible"
    >
      <enterprise
        :title="`${areaName}`"
        v-on:changeDataIndex="changeDataIndex"
        :region-code-def="areaCode"
        :data-range-def="dataRange"
        :times-def="times"
        year-def="year"
        quarter-def="quarter"
      ></enterprise>
    </el-dialog>
  </div>
</template>
<script>
import Area from "@/components/Echarts/area.vue";
import quarter from "@/components/dateUtils/quarter.vue";
import enterprise from "../content";
import { export2Excel } from "@/utils/utils";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      showArea: false,
      areaName: "",
      unit: "1",
      unitStr: "（千元）",
      unitStr1: "千元",
      dialogTableVisible: false,
      exportLabel: "<<点击此处可导出报表",
      queryData: {},
      currentPage: 1,
      page: 1,
      pageSize: 20,
      total: 0,
      loading: false,
      dataIndexOptions: [
        {
          value: "gyzcz",
          label: "工业增加值",
          unit: "千元",
        },
        {
          value: "yysr",
          label: "营业收入",
          unit: "千元",
        },
        {
          value: "lrze",
          label: "利润总额",
          unit: "千元",
        },
        {
          value: "yysj",
          label: "营业税金及附加",
          unit: "千元",
        },
        {
          value: "zzs",
          label: "应缴增值税",
          unit: "千元",
        },
        {
          value: "gyxscz",
          label: "工业销售产值",
          unit: "千元",
        },
        {
          value: "qyydl",
          label: "企业用电量",
          unit: "万千瓦时",
        },
      ],
      dataRangeOptions: [
        {
          value: "month",
          label: "月度",
        },
        {
          value: "quarter",
          label: "季度",
        },
        {
          value: "year",
          label: "年度",
        },
      ],
      dataTpye: "currMonth", //时间类型
      dataIndex: "gyzcz", //数据指标
      dataRange: "month", //数据类型
      times: "", //时间
      defaultQuarterValue: "", //时间
      defaultMonthValue: "", //时间
      quarter: 0,
      quarterDef: 0,
      year: 0,
      monthDef: 0,
      yearDef: 0,
      tableData: [],
      currMonth: "",
      srcTableData: [],
      areaData: {
        xAxis: [],
        curr: {
          name: "",
          data: [],
        },
        pre: {
          name: "",
          data: [],
        },
        profit: {
          name: "",
          data: [],
        },
        unit: "千元",
      },
      city_name: "",
    };
  },
  components: {
    Area,
    quarter,
    enterprise,
  },
  computed: {
    ...mapGetters({
      seatList: "getAreaListArr",
    }),
  },
  watch: {
    dataRange: function (value, oldValue) {
      this.quarter = this.quarterDef;
      this.year = this.yearDef;
      this.currMonth = this.defaultMonthValue;
      this.times = this.defaultMonthValue;
      this.initData();
    },
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.initData();
    },
    handleCurrentChange(val) {
      //跳转页
      this.page = val;
      this.initData();
    },
    handelFix1(row, column) {
      if (row[column.property] && !isNaN(row[column.property])) {
        return row[column.property].toFixed(1);
      } else {
        return row[column.property];
      }
    },
    handelFix2(row, column) {
      if (row[column.property] && !isNaN(row[column.property])) {
        return row[column.property].toFixed(2);
      } else {
        return row[column.property];
      }
    },
    dataRangeChange(value) {
      if (value === "month") {
        this.dataTpye = "currMonth";
      } else if (value === "quarter") {
        this.dataTpye = "currQuarter";
      } else {
        this.dataTpye = "all";
      }
    },
    showDialog(row) {
      this.showArea = false;
      this.areaName = row.district;
      this.areaCode = row.district;
      this.dialogTableVisible = true;
    },
    closeMe() {
      this.showArea = true;
      this.dialogTableVisible = false;
    },
    initData() {
      const self = this;
      this.loading = true;
      if (this.dataRange === "month") {
        this.queryData.dateType = "month";
        this.queryData.month = this.times;
      } else if (this.dataRange === "year") {
        this.queryData.dateType = "year";
        this.queryData.year = this.year;
        this.queryData.month = this.currMonth;
      } else {
        this.queryData.dateType = "quarter";
        this.queryData.quarter = this.quarter;
        this.queryData.year = this.year;
        this.queryData.month = this.currMonth;
      }
      this.$axios
        .post("/business/companyMonitor/queryByRegion", this.queryData)
        .then((res) => {
          this.tableData = [];
          this.areaData = {
            xAxis: [],
            curr: {
              name: "",
              data: [],
            },
            pre: {
              name: "",
              data: [],
            },
            profit: {
              name: "",
              data: [],
            },
            unit:
              this.dataIndexOptions.find((ele) => ele.value === this.dataIndex)
                .unit === "万千瓦时"
                ? "万千瓦时"
                : this.unitStr1,
          };
          this.showArea = false;
          this.srcTableData = res.data;
          this.total = res.data.length;
          this.getShowData();
          this.loading = false;
        });
    },
    getShowData() {
      const self = this;
      this.showArea = false;
      this.tableData = [];
      this.areaData = {
        xAxis: [],
        curr: {
          name: "",
          data: [],
        },
        pre: {
          name: "",
          data: [],
        },
        profit: {
          name: "",
          data: [],
        },
        unit:
          this.dataIndexOptions.find((ele) => ele.value === this.dataIndex)
            .unit === "万千瓦时"
            ? "万千瓦时"
            : this.unitStr1,
      };
      this.srcTableData.forEach((item) => {
        const obj = {
          district: item.district,
          totalNum: item.totalNum,
          czbId: item.czbId,
          addValue: item.addValue,
          cwbId: item.cwbId,
        };
        obj.this_month_gyzcz = item.this_month_gyzcz * this.unit;
        obj.last_year_month_gyzcz = item.last_year_month_gyzcz * this.unit;
        obj.this_month_yysr = item.this_month_yysr * this.unit;
        obj.last_year_month_yysr = item.last_year_month_yysr * this.unit;
        obj.this_month_yysj = item.this_month_yysj * this.unit;
        obj.last_year_month_yysj = item.last_year_month_yysj * this.unit;
        obj.this_month_lrze = item.this_month_lrze * this.unit;
        obj.last_year_month_lrze = item.last_year_month_lrze * this.unit;
        obj.this_month_zzs = item.this_month_zzs * this.unit;
        obj.last_year_month_zzs = item.last_year_month_zzs * this.unit;
        obj.this_month_gyxscz = item.this_month_gyxscz * this.unit;
        obj.last_year_month_gyxscz = item.last_year_month_gyxscz * this.unit;
        obj.this_month_qyydl = item.this_month_qyydl;
        obj.last_year_month_qyydl = item.last_year_month_qyydl;
        obj.gyzczRate =
          item.last_year_month_gyzcz > 0
            ? ((item.this_month_gyzcz - item.last_year_month_gyzcz) /
                item.last_year_month_gyzcz) *
              100
            : "--";
        obj.yysrRate =
          item.last_year_month_yysr > 0
            ? ((item.this_month_yysr - item.last_year_month_yysr) /
                item.last_year_month_yysr) *
              100
            : "--";
        obj.yysjRate =
          item.last_year_month_yysj > 0
            ? ((item.this_month_yysj - item.last_year_month_yysj) /
                item.last_year_month_yysj) *
              100
            : "--";
        obj.lrzeRate =
          item.last_year_month_lrze > 0
            ? ((item.this_month_lrze - item.last_year_month_lrze) /
                item.last_year_month_lrze) *
              100
            : "--";
        obj.zzsRate =
          item.last_year_month_zzs > 0
            ? ((item.this_month_zzs - item.last_year_month_zzs) /
                item.last_year_month_zzs) *
              100
            : "--";
        obj.gyxsczRate =
          item.last_year_month_gyxscz > 0
            ? ((item.this_month_gyxscz - item.last_year_month_gyxscz) /
                item.last_year_month_gyxscz) *
              100
            : "--";
        obj.qyydlRate =
          item.last_year_month_qyydl > 0
            ? ((item.this_month_qyydl - item.last_year_month_qyydl) /
                item.last_year_month_qyydl) *
              100
            : "--";
        this.tableData.push(obj);
        if (obj.district !== this.city_name && obj.district !== "") {
          this.areaData.xAxis.push(obj.district);
          this.areaData.curr.name = "当期";
          this.areaData.pre.name = "上年同期";
          this.areaData.profit.name = "同比增速";
          this.areaData.curr.data.push(obj["this_month_" + this.dataIndex]);
          this.areaData.pre.data.push(obj["last_year_month_" + this.dataIndex]);
          this.areaData.profit.data.push(obj[this.dataIndex + "Rate"]);
        }
      });

      setTimeout(function () {
        self.showArea = true;
      }, 5);
    },
    getQuarter(value) {
      this.times = value;
      this.year = value.slice(0, 4);
      const tmp = value.slice(5, 7);
      let month = "";
      if (tmp === "01") {
        this.quarter = 1;
        month = this.year + "-03";
      } else if (tmp === "04") {
        this.quarter = 2;
        month = this.year + "-06";
      } else if (tmp === "07") {
        this.quarter = 3;
        month = this.year + "-09";
      } else if (tmp === "10") {
        this.quarter = 4;
        month = this.year + "-12";
      }
      this.currMonth =
        this.defaultMonthValue > month ? month : this.defaultMonthValue;
      this.times = this.currMonth;
      this.initData();
    },
    getNowQuarter() {
      var today = new Date();
      var month = today.getMonth() + 1; //getMonth返回0-11
      var year = today.getFullYear(); //getMonth返回0-11
      this.year = year;
      this.yearDef = year;
      if (month < 10) {
        this.defaultMonthValue = year + "-0" + month;
      } else {
        this.defaultMonthValue = year + "-" + month;
      }
      //下面是几个if
      if (month >= 1 && month <= 3) {
        this.quarter = 1;
        this.quarterDef = 1;
        return year + "-" + "01" + "," + year + "-" + "03";
      } else if (month >= 4 && month <= 6) {
        this.quarter = 2;
        this.quarterDef = 2;
        return year + "-" + "04" + "," + year + "-" + "06";
      } else if (month >= 7 && month <= 9) {
        this.quarter = 3;
        this.quarterDef = 3;
        return year + "-" + "07" + "," + year + "-" + "09";
      } else if (month >= 10 && month <= 12) {
        this.quarter = 4;
        this.quarterDef = 4;
        return year + "-" + "10" + "," + year + "-" + "12";
      }
    },
    yearChange(value) {
      this.year = value;
      this.currMonth =
        this.year + "-12" > this.defaultMonthValue
          ? this.defaultMonthValue
          : this.year + "-12";
      this.times = this.currMonth;
      this.initData();
    },
    monthChange(value) {
      this.initData();
    },
    changeDataIndex(value) {
      if (value) {
        this.dataIndex = value;
      }
    },
    unitChange(value) {
      if (value === "1") {
        this.unitStr = "（千元）";
        this.unitStr1 = "千元";
      } else if (value === "0.1") {
        this.unitStr = "（万元）";
        this.unitStr1 = "万元";
      } else if (value === "0.00001") {
        this.unitStr = "（亿元）";
        this.unitStr1 = "亿元";
      }
      this.getShowData();
    },
    exportData() {
      let column = [
        {
          title: "地区",
          key: "district",
          rowspan: 2,
        },
        {
          title: "企业数",
          key: "totalNum",
          rowspan: 2,
        },
        {
          title: "工业总产值" + this.unitStr,
          data: [
            {
              title: "当期",
              toFixed: 2,
              key: "this_month_gyzcz",
            },
            {
              title: "上年同期",
              toFixed: 2,
              key: "last_year_month_gyzcz",
            },
            {
              title: "同比增速(%)",
              toFixed: 1,
              key: "gyzczRate",
            },
          ],
          colspan: 3,
        },
        {
          title: "工业销售产值" + this.unitStr,
          data: [
            {
              title: "当期",
              toFixed: 2,
              key: "this_month_gyxscz",
            },
            {
              title: "上年同期",
              toFixed: 2,
              key: "last_year_month_gyxscz",
            },
            {
              title: "同比增速(%)",
              toFixed: 1,
              key: "gyxsczRate",
            },
          ],
          colspan: 3,
        },
        {
          title: "营业收入" + this.unitStr,
          data: [
            {
              title: "当期",
              toFixed: 2,
              key: "this_month_yysr",
            },
            {
              title: "上年同期",
              toFixed: 2,
              key: "last_year_month_yysr",
            },
            {
              title: "同比增速(%)",
              toFixed: 1,
              key: "yysrRate",
            },
          ],
          colspan: 3,
        },
        {
          title: "利润总额" + this.unitStr,
          data: [
            {
              title: "当期",
              toFixed: 2,
              key: "this_month_lrze",
            },
            {
              title: "上年同期",
              toFixed: 2,
              key: "last_year_month_lrze",
            },
            {
              title: "同比增速(%)",
              toFixed: 1,
              key: "lrzeRate",
            },
          ],
          colspan: 3,
        },
        {
          title: "营业税金及附加" + this.unitStr,
          data: [
            {
              title: "当期",
              toFixed: 2,
              key: "this_month_yysj",
            },
            {
              title: "上年同期",
              toFixed: 2,
              key: "last_year_month_yysj",
            },
            {
              title: "同比增速(%)",
              toFixed: 1,
              key: "yysjRate",
            },
          ],
          colspan: 3,
        },
        {
          title: "应缴增值税" + this.unitStr,
          data: [
            {
              title: "当期",
              toFixed: 2,
              key: "this_month_zzs",
            },
            {
              title: "上年同期",
              toFixed: 2,
              key: "last_year_month_zzs",
            },
            {
              title: "同比增速(%)",
              toFixed: 1,
              key: "zzsRate",
            },
          ],
          colspan: 3,
        },
        {
          title: "企业用电量（万千瓦时）",
          data: [
            {
              title: "当期",
              toFixed: 2,
              key: "this_month_qyydl",
            },
            {
              title: "上年同期",
              toFixed: 2,
              key: "last_year_month_qyydl",
            },
            {
              title: "同比增速(%)",
              toFixed: 1,
              key: "qyydlRate",
            },
          ],
          colspan: 3,
        },
        // {
        //   title: "增加值率",
        //   key: "addValue",
        //   toFixed: 1,
        //   rowspan: 2,
        // },
      ];
      console.log("this.times:", this.times);
      let timeStr = "";
      if (this.dataRange === "year") {
        timeStr = this.times.slice(0, 4) + "年";
      } else if (this.dataRange === "quarter") {
        const temp = parseInt(this.times.slice(5, 7));
        let quarter = "";
        if (temp < 4) {
          quarter = "1";
        } else if (temp < 7) {
          quarter = "2";
        } else if (temp < 10) {
          quarter = "3";
        } else if (temp < 13) {
          quarter = "4";
        }
        timeStr = this.times.slice(0, 4) + "年第" + quarter + "季度";
      } else {
        timeStr = this.times.slice(0, 4) + "年" + this.times.slice(5, 7) + "月";
      }
      export2Excel(
        column,
        this.tableData,
        this.dataIndexOptions.find((ele) => ele.value === this.dataIndex)
          .label +
          "_" +
          timeStr
      );
    },
  },
  created() {
    this.defaultQuarterValue = this.getNowQuarter();
    this.times = this.defaultMonthValue;
    this.currMonth = this.defaultMonthValue;
    this.initData();
    if (this.seatList.length) {
      this.city_name = this.seatList[0];
    }
  },
};
</script>